import type { PublicMenuItem } from '@/features/themes/lib/useSiteMenu';

/**
 * Monta o href de um item de menu no contexto do site público.
 * - Página interna: rota /s/:slug/:pageSlug (react-router interno).
 * - URL externa / âncora: o próprio url.
 * Retorna null quando o item não tem destino resolvível (ex.: página sem slug).
 */
export function buildMenuHref(item: PublicMenuItem, siteSlug: string): string | null {
  if (item.page_id) {
    return item.page_slug ? `/s/${siteSlug}/${item.page_slug}` : null;
  }
  return item.url || null;
}

/** Item interno é aquele que aponta para uma página do próprio site (navegação SPA). */
export function isInternalItem(item: PublicMenuItem): boolean {
  return !!item.page_id;
}
